module.exports = __webpack_public_path__ + "img/Roast_Chicken.f6610428.jpg";